import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YourFavouritesComponent } from './your-favourites.component';
import { IteratorDirective } from '../shared/directives/iterator/iterator.directive';
import { FavouriteSiteComponent } from './favourite-site/favourite-site.component';
import { SitePopupInfoWidgetComponent } from '../shared/site-popup-info-widget/site-popup-info-widget.component';
import { BreadCrumbComponent } from '../shared/bread-crumb/bread-crumb.component';
import { SitesDetailsService } from '../services/sitedetails.service';
import { CookiesService } from '../CookieService';
import { HeroBannerComponent } from '../shared/hero-banner/hero-banner.component';
import { FavouriteIconComponent } from '../shared/favourite-icon/favourite-icon.component';
import { RouterModule } from '@angular/router';
import { SitesService } from '../services/sites.service';
import { SharedCompsModule } from '../shared/shared-comps.module';

@NgModule({
	declarations: [YourFavouritesComponent, FavouriteSiteComponent],
	imports: [
		CommonModule,
		RouterModule,
		SharedCompsModule,
		IteratorDirective
	],
	exports : [YourFavouritesComponent],
	providers : [SitesDetailsService, CookiesService, SitesService]
})
export class FavouritesModule { }
